import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const NONE = "__none__";

export function OperatoreResponsabileSelect({ structureId, value, onChange, testid }) {
  const { data: ops = [] } = useQuery({
    queryKey: ["op-responsabile", structureId],
    enabled: !!structureId,
    queryFn: async () => (await api.get("/firma/operatori", { params: { structure_id: structureId } })).data,
  });
  const nomeOp = (o) => `${o.cognome || ""} ${o.nome || ""}`.trim();
  const sorted = [...ops].sort((a, b) => nomeOp(a).localeCompare(nomeOp(b)));
  return (
    <Select value={value || NONE} disabled={!structureId}
      onValueChange={(v) => { const o = ops.find((x) => x.id === v); onChange(v === NONE ? { id: "", nome: "" } : { id: v, nome: o ? `${o.nome || ""} ${o.cognome || ""}`.trim() : "" }); }}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder={structureId ? "Seleziona operatore" : "Scegli prima la struttura"} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>— Nessuno —</SelectItem>
        {sorted.map((o) => <SelectItem key={o.id} value={o.id}>{nomeOp(o)}{o.qualifica ? ` · ${o.qualifica}` : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
